import React, { createContext, useContext, useEffect, useState } from 'react';

// Contexto para Dark Mode
const DarkModeContext = createContext();

// Proveedor del Contexto
export const DarkModeProvider = ({ children }) => {
	// Inicializar estado desde localStorage
	const [darkMode, setDarkMode] = useState(() => {
		const savedMode = localStorage.getItem('darkMode');
		return savedMode ? JSON.parse(savedMode) : false; // Por defecto, modo claro
	});

	// Actualizar localStorage cada vez que darkMode cambie
	useEffect(() => {
		localStorage.setItem('darkMode', JSON.stringify(darkMode));
	}, [darkMode]);

	const toggleDarkMode = () => setDarkMode((prevMode) => !prevMode);

	return (
		<DarkModeContext.Provider value={{ darkMode, toggleDarkMode }}>
			{children}
		</DarkModeContext.Provider>
	);
};

// Hook para usar el contexto en los hijos
export const useDarkMode = () => useContext(DarkModeContext);
